import { z } from 'zod'

// ============================================
// PRODUIT SCHEMA
// ============================================

export const produitSchema = z.object({
  id: z.string().uuid(),
  nom: z.string().min(1, 'Le nom est requis'),
  description: z.string().nullable(),
  prix_unitaire: z.number().min(0, 'Le prix doit être positif'), // Prix en euros
  devise: z.string().default('EUR'),
  tva: z.number().min(0).max(100).default(20),
  code: z.string().nullable(),
  temps_estime: z.string().nullable(),
  created_at: z.string(),
  updated_at: z.string(),
})

export const produitInsertSchema = produitSchema.omit({
  id: true,
  created_at: true,
  updated_at: true,
})

export const produitUpdateSchema = produitInsertSchema.partial()

// ============================================
// TYPES
// ============================================

export type Produit = z.infer<typeof produitSchema>
export type ProduitInsert = z.infer<typeof produitInsertSchema>
export type ProduitUpdate = z.infer<typeof produitUpdateSchema>

// ============================================
// FORM DATA
// ============================================

export interface ProduitFormData {
  nom: string
  description: string | null
  prix_unitaire: number // Prix en euros
  devise?: string
  tva?: number
  code?: string | null
  temps_estime?: string | null
}

// ============================================
// FILTERS
// ============================================

export interface ProduitFilters {
  search?: string
  page?: number
  limit?: number
}

// ============================================
// HELPERS
// ============================================

// Formater le prix pour l'affichage
export function formatProduitPrice(euros: number): string {
  return `${euros.toFixed(2)} €`
}
